var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg160Chat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.382,68.512C388.111,24.331,324.049,0,256.001,0S123.892,24.331,75.621,68.512 C26.857,113.143,0.001,172.625,0.001,236c0,49.425,16.162,96.253,46.87,136.172L1.459,484.503 c-3.051,7.547-1.224,16.19,4.621,21.856C9.89,510.052,14.908,512,20.006,512c2.723,0,5.469-0.556,8.063-1.699l128.656-56.714 C188.166,465.809,221.522,472,256.001,472c43.157,0,85.828-10.086,123.399-29.168c9.848-5.002,13.777-17.04,8.775-26.889 c-5.002-9.848-17.04-13.776-26.889-8.775C329.3,423.413,292.894,432,256.001,432c-32.053,0-62.918-6.234-91.737-18.529 c-5.09-2.172-10.852-2.137-15.916,0.095l-91.345,40.266l31.366-77.589c2.793-6.909,1.514-14.799-3.321-20.47 C55.578,321.2,40.001,279.783,40.001,236c0-108.075,96.897-196,216-196s216,87.925,216,196c0,37.216-11.548,73.426-33.398,104.714 c-6.324,9.056-4.11,21.524,4.947,27.848c9.054,6.325,21.525,4.109,27.848-4.947c26.563-38.037,40.603-82.166,40.603-127.615 C512.001,172.625,485.146,113.143,436.382,68.512z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg160Chat);
export default __webpack_public_path__ + "static/media/160-chat.fc73e2a3409855a6f9ad63171de356ca.svg";
export { ForwardRef as ReactComponent };